import { IContentRequest } from '@/editor/api/services/types/requests';
import {
  IImageUpload,
  ISelection,
  IMenuCommand,
  ITextMenuState,
  IImageMenuState,
  IHover,
  IEditorBlock,
  IImageSearchState,
} from '@/editor/types';
import { EContext } from '@/editor/types/enums';
import { FormMenuState } from '@/editor/types/form-menu-state';

export interface IEditorUiState {
  context: EContext;
  selected: ISelection;
  hovered: IHover;
  textMenuState: ITextMenuState;
  imageMenuState: IImageMenuState;
  formMenuState: FormMenuState;
  menuCommand: IMenuCommand;
  imageUpload: IImageUpload;
  updateQueue: IUpdateRequest[];
  isUpdating: boolean;
  blockToUpdate: IEditorBlock;
  imageSearchState: IImageSearchState;
}

export interface IUpdateRequest {
  contentId: string;
  type: EContentRequestType;
  payload: IContentRequest;
  blockBeforeUpdate: IEditorBlock;
}

export enum EContentRequestType {
  UpdateCells,
  CreateRow,
  SplitTextCreateRow,
  DeleteRow,
  UpdateRow,
  MoveRow,
  MoveNodes,
  MoveCell,
  UpdateNode,
  DeleteNode,
}
